
<section >
  <div>
    @switch (buttonType) {
      @case ('basic') {
        <button mat-button [color]="color" [disabled]="disabled" (click)="onClick()">{{buttonName}}</button>
      }
      @case ('raised') {
        <button  mat-raised-button [color]="color" [disabled]="disabled" (click)="onClick()">{{buttonName}}</button>
      }
      @case ('stroked') {
        <button mat-stroked-button [color]="color" [disabled]="disabled" (click)="onClick()">{{buttonName}}</button>
      }
      @case ('flat') {
        <button mat-flat-button [color]="color" [disabled]="disabled" (click)="onClick()">{{buttonName}}</button>
      }
    }
  </div>
</section>
